<template>
  <div class="search-form">
    <slot name="before"></slot>
    <course-select style="width:120px;" @input="handleInput"></course-select>
    <el-select
      v-model="inputLevel"
      filterable
      placeholder="等级"
      :clearable="true"
      style="width: 100px;;"
    >
      <el-option
        v-for="item in $store.getters.levels"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>
    <el-input v-model="inputNum" placeholder="序号" style="width: 80px;flex:none;" />
    <slot></slot>
    <el-input
      v-model="inputSearch"
      placeholder="输入关键字搜索"
      style="width: 200px"
    />
    <slot name="after"></slot>
  </div>
</template>

<script>
import _ from "lodash";
import CourseSelect from "@/components/CourseSelect.vue";

export default {
  name: "SearchForm",
  components: {CourseSelect},
  props: {
    store: String,
  },
  data() {
    return {
      level: null,
      num: null,
      search: null,
    };
  },
  computed: {
    inputLevel: {
      get() {
        return this.getInputValue("level");
      },
      set(val) {
        this.setInputValue("level", val);
      },
    },
    inputNum: {
      get() {
        return this.getInputValue("num");
      },
      set(val) {
        this.setInputValue("num", val);
      },
    },
    inputSearch: {
      get() {
        return this.getInputValue("search");
      },
      set(val) {
        this.setInputValue("search", val);
      },
    },
  },
  created() {
    this.handleInput = _.debounce(this.handleInput, 100);
  },
  methods: {
    initSearch(values) {
      Object.assign(this, values)
      this.handleInput()
    },
    getInputValue(name) {
      if (this.store && this.$store.state[this.store]) {
        const store = this.$store.state[this.store];
        if (name in store) {
          if (this[name] != store[name]) {
            this.setValue(name, store[name]);
          }
        }
      }
      return this[name];
    },
    setInputValue(name, value) {
      if (this.store) {
        const fn = this.store + "/set" + _.upperFirst(name);
        if (fn in this.$store._mutations) {
          this.$store.commit(fn, value);
        }
      }
      this.setValue(name, value);
    },
    setValue(name, value) {
      this[name] = value;
      this.handleInput();
    },
    handleInput() {
      this.$emit("change", {
        level: this.level,
        num: this.num,
        search: this.search,
      });
    },
  },
};
</script>